import React, { useState, useEffect } from 'react';
import {
  HashRouter as Router,
} from "react-router-dom";
import Header from './Header';
import Footer from './Footer';
import languages, { getDefaultLanguage, getDirectionality, loadLocaleFile } from './languages';

import './App.css';

const isWorld = process.env.REACT_APP_ENV === 'world';

const noop = () => {}

function App() {
  const [Container, setContainer] = useState(null);
  useEffect(() => {
    if (isWorld) {
      import('./WorldContainer')
        .then(module => setContainer(module))
        .catch(err => console.warn(err));
    } else {
      import('./USContainer')
        .then(module => setContainer(module))
        .catch(err => console.warn(err));
    }
  }, []);

  let embedParams = null
  const queryParams = new URLSearchParams(document.location.search);

  const defaultUserLanguage = getDefaultLanguage()
  const [language, setLanguage] = useState(getDefaultLanguage)

  let unloadedContentLanguage = isWorld ? defaultUserLanguage : 'en'

  if (queryParams.has('l')) {
    const languageQueryParam = queryParams.get('l')
    const matching = languages.find(d => d.code === languageQueryParam)
    if (matching) {
      unloadedContentLanguage = languageQueryParam
    }
  }

  useEffect(() => {
    const defaultLanguageToLoad = unloadedContentLanguage
    loadLocaleFile(defaultLanguageToLoad).then(() => {
      setLanguage(defaultLanguageToLoad)
    })
  }, [unloadedContentLanguage])
  const directionality = getDirectionality(language)

  if (queryParams.has('embed')) {
    const embedQueryParam = queryParams.get('embed')
    if (['stateCounty', 'usa', 'state', 'county', 'world', 'country', 'countryRegion'].includes(embedQueryParam)) {
      embedParams = embedQueryParam
    }
  }

  const defaultContent = (
    <React.Fragment>
      {embedParams === null ? (
        <Header
          setRegionValue={noop}
          regionValue=''
          dateUpdated=''
          closeCounty={noop}
          zipcodes={[]}
          isWorld={isWorld}
          usCountyPopulations={{}}
          language={unloadedContentLanguage}
          directionality={directionality}
        />
      ) : null }
      <div style={{ height: 'calc(100vh - 142px)'}} />
      <Footer
        dateUpdated={noop}
        embedParams={embedParams}
        language={unloadedContentLanguage}
        directionality={directionality}
        isWorld={isWorld}
      />
    </React.Fragment>
  );

  return (
    <div className="App" style={{ direction: directionality }}>
      <Router>
        {
          Container ? (
            <Container.default
              embedParams={embedParams}
              defaultContent={defaultContent}
              language={language}
              setLanguage={setLanguage}
              directionality={directionality}
            />
          ) : defaultContent
        }
      </Router>
    </div>
  );
}

export default App;
